import { useCallback } from 'react';

import { setIsSignedOutManually } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useAuth } from 'modules/auth/hooks/useAuth';

export const useSignOutHandler = () => {
  const { handleSignOut } = useAuth();

  const dispatch = useAppDispatch();

  const signOut = useCallback(() => {
    dispatch(setIsSignedOutManually(true));

    handleSignOut();
  }, [dispatch, handleSignOut]);

  return { signOut };
};
